import {
  PixApprovedTransaction,
  PixPaymentResponse,
  PixPaymentResponseRaw,
} from "modules/payment/domain/models/PixApprovedTransaction";

export function normalizePixResponse(
  raw: PixPaymentResponseRaw | null | undefined | ""
): PixPaymentResponse | null {
  if (!raw) return null;

  const paymentId = raw.paymentId ?? raw.id ?? raw.Id;
  if (!paymentId) return null;

  return {
    ownerId: raw.ownerId ?? raw.OwnerId,
    paymentId,
    qrCodeBase64: raw.qrCodeBase64 ?? raw.QrCodeBase64,
    qrCodeLink: raw.qrCodeLink ?? raw.QrCodeLink,
    status: raw.status ?? raw.Status,
    value: raw.value ?? raw.Value,
    createdAt: raw.createdAt ?? raw.CreatedAt,
    approvedAt: raw.approvedAt ?? raw.ApprovedAt,
    acquirerType: raw.acquirerType ?? raw.AcquirerType,
    endToEndId: raw.endToEndId ?? raw.EndToEndId,
  } as PixPaymentResponse;
}

// Envelope que a POS espera em transactionResponse (sem o QR code em base64)
export function buildPixTransactionResponse(
  pix: PixApprovedTransaction
): string {
  const { qrCodeBase64, ...rest } = pix as PixApprovedTransaction & {
    qrCodeBase64?: string;
  };
  return JSON.stringify({
    ...rest,
    status: 0,
    transactionId: rest.paymentId,
    log: JSON.stringify(rest),
  });
}
